import { render } from "./BuybackRma.vue?vue&type=template&id=bd842a78&scoped=true&ts=true&lang=pug"
import script from "./BuybackRma.vue?vue&type=script&lang=ts"
export * from "./BuybackRma.vue?vue&type=script&lang=ts"

import "./BuybackRma.vue?vue&type=style&index=0&id=bd842a78&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd842a78"]])

export default __exports__